import config from "@Config/index";
import extractPlainText from "@Pages/Blog/Author/utils/extractPlainText";
import getBlogImageUrl from "./getBlogImageUrl";

export const SITE_URL = `https://amberstudent.${config.IS_CHINA_APP ? "cn" : "com"}`;
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

const EDITORIAL_TEAM_SLUG = "amber-editorial-team";

export const getAuthorPageUrl = (slug: string) => `${SITE_URL}/blog/author/${slug}`;

export const isPersonContributor = (contributor: any): boolean =>
  Boolean(contributor?.slug) && contributor.slug !== EDITORIAL_TEAM_SLUG;

export const getContributorRef = (contributor: any) => ({
  "@id": isPersonContributor(contributor)
    ? `${getAuthorPageUrl(contributor.slug)}#person`
    : ORGANIZATION_ID,
});

export const getPersonNode = (contributor: any) => {
  const description = extractPlainText(contributor?.description).replace(/\s+/g, " ").trim();
  const image = contributor?.image?.url ? getBlogImageUrl(contributor.image.url) : undefined;
  const sameAs = [contributor?.socials?.linkedin, contributor?.socials?.twitter].filter(Boolean);
  const knowsAbout = (contributor?.tags || []).filter(
    (tag: unknown) => typeof tag === "string" && tag,
  );

  return {
    "@type": "Person",
    ...getContributorRef(contributor),
    name: contributor.name,
    url: getAuthorPageUrl(contributor.slug),
    ...(contributor.role ? { jobTitle: contributor.role } : {}),
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    worksFor: { "@id": ORGANIZATION_ID },
    ...(sameAs.length ? { sameAs } : {}),
    ...(knowsAbout.length ? { knowsAbout } : {}),
  };
};

const websiteNode = {
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  url: `${SITE_URL}/`,
  name: "amber",
  publisher: { "@id": ORGANIZATION_ID },
};

const organizationNode = {
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "amberstudent",
  url: SITE_URL,
  logo: `${config.IMAGE_STATIC_URL}/images/logo/amber_red_logo_small_1.png`,
};

export const toSchemaGraph = (nodes: Record<string, unknown>[]) => [
  { "@context": "https://schema.org", "@graph": [websiteNode, organizationNode, ...nodes] },
];
